module.exports = __webpack_public_path__ + "static/img/service_1.290543c0.png";